<template>
  <div class="referral-card-info">
    <div class="referral-content">
      <slot name="status">
      </slot>
      <el-avatar class="photo" :src="referralInfo.is_candidate ? $DjangoMediaUrl(referralInfo.photo_url) : referralInfo.photo_url" @click="toJobDetailPage(referralInfo.apply_job_id[0])">
        <img :src="$DjangoStaticUrl('images_en/default.jpg')"/>
      </el-avatar>
      <div v-auto-tooltip class="job-name">{{ referralInfo.job?.jobTitle }}</div>
      <div v-auto-tooltip class="candidate-name">{{ referralInfo.name }}</div>
      <div class="create-time">{{ formatCreateTime(referralInfo.create_time) }}</div>
      <div v-if="isShowMaxReword" class="potential-reward">
        <span>{{ $t(`${i18nPrefix}.reward.potential`) }}</span>
        <i class="reward-icon iconfont iconmoney"></i>
        <span>￥{{ referralInfo.max_rewards[0]|formatBigNumber(1) }}/</span>
        <i class="reward-icon iconfont iconpoint1"></i>
        <span>{{ referralInfo.max_rewards[1]|formatBigNumber(1) }}</span>
      </div>
      <div v-if="isAppliedList && isShowHasGotReword"  class="future-reward">
        <i class="reward-icon iconfont iconmoney"></i>
        <span>￥{{ referralInfo.has_got_reward[0]|formatBigNumber(1) }}/</span>
        <i class="reward-icon iconfont iconpoint1"></i>
        <span>{{ referralInfo.has_got_reward[1]|formatBigNumber(1)  }}</span>
      </div>
    </div>
    <ReferralChain
      class="referral-chain"
      :referralChain="referralInfo.referral_chain"
      :isAppliedList="isAppliedList"
      :jobId="referralInfo.apply_job_id[0]"
      :companyId="referralInfo.company_id"
    >
    </ReferralChain>
  </div>
</template>

<script>
import moment from 'moment'
import ReferralChain from './referralChain.vue'

export default {
  components: {
    ReferralChain
  },
  props: {
    referralInfo: {
      type: Object,
      required: true
    },
    isAppliedList: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.leads'
    }
  },
  computed: {
    isShowMaxReword () {
      // array[0] is cash, [1] is point
      return (this.referralInfo.max_rewards[0] + this.referralInfo.max_rewards[1]) > 0
    },
    isShowHasGotReword () {
      // array[0] is cash, [1] is point
      return (this.referralInfo.has_got_reward[0] + this.referralInfo.has_got_reward[1]) > 0
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    toJobDetailPage (jobId) {
      window.location.href = this.$DjangoBaseUrl(`/job-detail-new/${jobId}/c/`)
    },
    formatCreateTime (time) {
      const date = moment(time)
      const formatted = date.isSame(moment(), 'day')
        ? this.$t(`${this.i18nPrefix}.label.today`)
        : date.isSame(moment().subtract(1, 'day'), 'day')
          ? this.$t(`${this.i18nPrefix}.label.yesterday`)
          : date.format('YYYY/MM/DD')

      return formatted
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-card-info {
  width: 235px;
  height: 312px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.12);
  border-radius: 4px;

  .referral-content {
    display: flex;
    padding: 14px 0;
    height: 210px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #dcdfe6;

    .photo {
      flex-shrink: 0;
      width: 60px;
      height: 60px;
      background-color: #fff;

      .default-icon {
        font-size: 60px;
        position: relative;
        top: 10px;
        color: #dcdfe6;
      }

      ::v-deep {
        img {
          margin: auto;
        }
      }
    }

    .job-name {
      padding: 0 20px;
      flex-shrink: 0;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      color: #303133;
      line-height: 20px;
      font-size: 14px;
      margin-top: 8px;
    }

    .candidate-name {
      flex-shrink: 0;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      font-size: 14px;
      color: #606266;
      line-height: 20px;
      margin-top: 4px;
    }

    .create-time {
      font-size: 12px;
      color: #909399;
      line-height: 16px;
      margin-top: 4px;
    }

    .potential-reward {
      font-size: 12px;
      color: #909399;
      line-height: 16px;
      margin-top: 8px;

      .reward-icon {
        font-size: 12px;
        margin: 0 2px;
      }

      > * {
        vertical-align: middle;
      }
    }

    .future-reward {
      font-size: 12px;
      color: #0096CC;
      line-height: 16px;
      margin-top: 8px;

      .reward-icon {
        font-size: 12px;
        margin: 0 2px;
      }

      > * {
        vertical-align: middle;
      }
    }
  }

  .referral-chain {
    overflow-x: auto;
    overflow-y: hidden;
    height: 98px;
    padding: 14px 0;
    margin: 0 20px;
  }
}
</style>
